import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import { GoTriangleDown } from 'react-icons/go';
import { useLocation } from 'react-router';

import { useClickOutside } from '@/hooks/useClickOutside';
import * as styles from './Style.module.scss';

type Props = {
  dataTest?: string;
  text: string;
  buttonClassNames?: string | string[];
  menuWrapperClassNames?: string | string[];
  menuNode: React.ReactNode;
};

export const Dropdown: React.FC<Props> = ({
  dataTest,
  text,
  buttonClassNames,
  menuWrapperClassNames,
  menuNode,
}) => {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const { ref: menuRef } = useClickOutside(() => setOpen(false));

  useEffect(() => {
    setOpen(false);
  }, [location, text]);

  return (
    <div className={styles.root} ref={menuRef}>
      <div
        data-test={dataTest}
        className={classNames(
          buttonClassNames,
          styles.menuToggleButton,
          open && 'opened',
        )}
        onClick={() => {
          setOpen(!open);
        }}
      >
        <div>{text}</div>

        <GoTriangleDown />
      </div>

      {open && (
        <div className={classNames(styles.menuWrapper, menuWrapperClassNames)}>
          {menuNode}
        </div>
      )}
    </div>
  );
};
